import React from 'react';
import PillarPageTemplate from '../../components/PillarPageTemplate';
import { permis125PermisBData } from '../../data/pillars/permis125PermisB';

export default function PillarPermis125PermisB() {
  return <PillarPageTemplate data={permis125PermisBData} />;
}
